/** @format */
import { Education, Module } from 'common-typescript/types';

/**
 * Returns a sorting function that can be used as an argument for `Array.sort()`. The function sorts
 * modules based on the structure of the given education, so that any module contained in the phase 1
 * options in the education structure comes before other modules. This function is mainly intended to be
 * used for sorting the top-level modules (e.g. degree programs) in a study plan.
 *
 * Modules not found in the education structure are considered equal and retain their relative order.
 * In addition, phase 2 modules are considered equal to modules not found in the education structure,
 * as their relative order isn't well-defined. This means that if none of the modules being compared
 * are found in the phase 1 options, their order remains unchanged.
 *
 * @param education The education whose structure is used for sorting
 */
export function modulesByEducationPhase(education: Education): (a: Module, b: Module) => number {
    return (a: Module, b: Module) => {
        if (!education?.structure?.phase1?.options) {
            return 0;
        }

        if (education.structure.phase1.options.some(option => option?.moduleGroupId === a?.groupId)) {
            return -1; // a comes before b
        }
        if (education.structure.phase1.options.some(option => option?.moduleGroupId === b?.groupId)) {
            return 1; // b comes before a
        }
        return 0;
    };
}
